"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.target.client': 'Klient',
    'slot.target.coworker': 'Współpracownik',
    'slot.target.manager': 'Menedżer',
    'slot.target.self': 'Ja',
};
